var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24839 1.74951H2.33266C2.01059 1.74951 1.74951 2.01059 1.74951 2.33266V5.24839C1.74951 5.57045 2.01059 5.83153 2.33266 5.83153H5.24839C5.57045 5.83153 5.83153 5.57045 5.83153 5.24839V2.33266C5.83153 2.01059 5.57045 1.74951 5.24839 1.74951Z",
    stroke: "#101828",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6629 1.74951H8.74721C8.42515 1.74951 8.16406 2.01059 8.16406 2.33266V5.24839C8.16406 5.57045 8.42515 5.83153 8.74721 5.83153H11.6629C11.985 5.83153 12.2461 5.57045 12.2461 5.24839V2.33266C12.2461 2.01059 11.985 1.74951 11.6629 1.74951Z",
    stroke: "#101828",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6629 8.16406H8.74721C8.42515 8.16406 8.16406 8.42515 8.16406 8.74721V11.6629C8.16406 11.985 8.42515 12.2461 8.74721 12.2461H11.6629C11.985 12.2461 12.2461 11.985 12.2461 11.6629V8.74721C12.2461 8.42515 11.985 8.16406 11.6629 8.16406Z",
    stroke: "#101828",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24839 8.16406H2.33266C2.01059 8.16406 1.74951 8.42515 1.74951 8.74721V11.6629C1.74951 11.985 2.01059 12.2461 2.33266 12.2461H5.24839C5.57045 12.2461 5.83153 11.985 5.83153 11.6629V8.74721C5.83153 8.42515 5.57045 8.16406 5.24839 8.16406Z",
    stroke: "#101828",
    strokeWidth: 1.16629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.5b91adb66a0ad55db1fd7feb79a81ea7.svg";
export { ForwardRef as ReactComponent };